/**
 * Läuft die Seite in der Verwaltung der App (`mobile/app/verwaltung.tsx`)? Die App hängt
 * `RadeventsApp` an den User-Agent ihrer WebView. Dort hat die App die Anmeldung in der Hand:
 * „Abmelden" und „Passwort ändern" der Seite beenden im Backend alle Sitzungen, auch die der App,
 * und fehlen deshalb.
 */
export const istInApp = (): boolean =>
  typeof navigator !== 'undefined' && /RadeventsApp/.test(navigator.userAgent);
